/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v25.3.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
export var ServerSideTransactionResultStatus;
(function (ServerSideTransactionResultStatus) {
    ServerSideTransactionResultStatus["StoreNotFound"] = "StoreNotFound";
    ServerSideTransactionResultStatus["StoreLoading"] = "StoreLoading";
    ServerSideTransactionResultStatus["StoreWaitingToLoad"] = "StoreWaitingToLoad";
    ServerSideTransactionResultStatus["StoreLoadingFailed"] = "StoreLoadingFailed";
    ServerSideTransactionResultStatus["StoreWrongType"] = "StoreWrongType";
    ServerSideTransactionResultStatus["Applied"] = "Applied";
    ServerSideTransactionResultStatus["Cancelled"] = "Cancelled";
})(ServerSideTransactionResultStatus || (ServerSideTransactionResultStatus = {}));
